import React, { forwardRef } from 'react';
import { Types } from '@fiverr-private/theme';
import Layout from '../../Layout';

const WrapItem = forwardRef<HTMLElement, Types.FlexLayoutProps>(
  ({ children, ...restProps }: Types.FlexLayoutProps, ref) => (
    <Layout ref={ref} {...restProps}>
      {children}
    </Layout>
  )
);

WrapItem.displayName = 'WrapItem';

export default WrapItem;
